/**
 * Do not edit directly
 * Generated on Thu, 19 Aug 2021 21:48:11 GMT
 */
export const PadXs = "2px";
export const PadS = "4px";
export const PadM = "6px";
export const PadL = "8px";
export const PadXl = "10px";
export const PadXxl = "12px";
export const PadXxxl = "16px";
